import { z } from "zod";

// Auth Errors
export enum AuthErrorType {
  NETWORK = "network",
  INVALID_CREDENTIALS = "invalid_credentials",
  EXPIRED_SESSION = "expired_session",
  SERVER_ERROR = "server_error",
  UNKNOWN = "unknown",
}

export interface AuthError extends Error {
  type: AuthErrorType;
  originalError?: unknown;
}

// Helper to create typed auth errors
export const createAuthError = (
  message: string,
  type: AuthErrorType = AuthErrorType.UNKNOWN,
  originalError?: unknown
): AuthError => {
  const error = new Error(message) as AuthError;
  error.type = type;
  error.originalError = originalError;
  return error;
};

// Permission Types
export const EntityInstanceSchema = z.object({
  id: z.number(),
  type: z.string(),
  name: z.string(),
});
export type EntityInstance = z.infer<typeof EntityInstanceSchema>;

export interface EntityInstanceDto {
  entity_id: number;
  entity_type: string;
  entity_name: string;
}

export interface EntityPermission {
  entity: EntityInstanceDto;
  actions: string[];
}

// Auth Types (User coming from server)
export interface User {
  id: string;
  email: string;
  avatar?: string;
  groups: string[];
  first_name: string;
  last_name: string;
  permissions: EntityPermission[];
  actions: string[];
}

export interface AuthState {
  user: User | null;
  isLoading: boolean;
  isAuthenticated: boolean;
  error: Error | null;
}











